import { create } from 'zustand'
import api from '../api/client'

// Logout automático por inatividade
let logoutTimer = null

function resetTimer(logoutFn, minutes) {
  if (logoutTimer) clearTimeout(logoutTimer)
  if (!minutes || minutes <= 0) return
  logoutTimer = setTimeout(logoutFn, minutes * 60 * 1000)
}

const useAuthStore = create((set, get) => ({
  user: null,
  loading: false,
  error: null,

  init: () => {
    const stored = localStorage.getItem('user')
    if (stored) {
      const user = JSON.parse(stored)
      set({ user })
      // Reinicia o timer ao recarregar a página
      const timeout = user.sessionTimeout || 60
      const logout = () => get().logout()
      resetTimer(logout, timeout)
      // Resetar o timer em atividade do utilizador
      const events = ['mousedown', 'keydown', 'scroll', 'touchstart']
      events.forEach(e => document.addEventListener(e, () => resetTimer(logout, timeout)))
    }
  },

  login: async (email, password) => {
    set({ loading: true, error: null })
    try {
      const { data } = await api.post('/auth/login', { email, password })
      localStorage.setItem('accessToken', data.accessToken)
      localStorage.setItem('refreshToken', data.refreshToken)
      localStorage.setItem('user', JSON.stringify(data.user))
      set({ user: data.user, loading: false })

      // Iniciar timer de logout
      const timeout = data.user.sessionTimeout || 60
      const logout = () => get().logout()
      resetTimer(logout, timeout)
      const events = ['mousedown', 'keydown', 'scroll', 'touchstart']
      events.forEach(e => document.addEventListener(e, () => resetTimer(logout, timeout)))

      return data.user
    } catch (err) {
      const msg = err.response?.data?.erro || 'Erro ao fazer login.'
      set({ error: msg, loading: false })
      throw new Error(msg)
    }
  },

  logout: async () => {
    if (logoutTimer) clearTimeout(logoutTimer)
    try {
      const refresh = localStorage.getItem('refreshToken')
      await api.post('/auth/logout', { refreshToken: refresh })
    } catch {}
    localStorage.clear()
    set({ user: null })
  }
}))

export default useAuthStore
